import ActiveControlledSubscriptionMembership from './components/ActiveControlledSubscriptionMembership';
import ActiveControlledSubscriptionWithShipment from './components/ActiveControlledSubscriptionWithShipment';
import ActiveSubscriptionMembership from './components/ActiveSubscriptionMembership';
import ActiveSubscriptionWithShipment from './components/ActiveSubscriptionWithShipment';
import ActiveTraditionalMembership from './components/ActiveTraditionalMembership';
import ActiveTraditionalWithShipment from './components/ActiveTraditionalWithShipment';
import CancelledMembership from './components/CancelledMembership';

const ClubMembershipDisplay = (props) => {
  const { clubMembership } = props;
  if (clubMembership.status === 'Cancelled') {
    return <CancelledMembership clubMembership={clubMembership} />;
  }
  // Subscription Clubs
  if (clubMembership.clubType === 'Subscription') {
    if (!clubMembership.activeClubSubscriptionShipmentId) {
      return <ActiveSubscriptionMembership clubMembership={clubMembership} />;
    }
    return <ActiveSubscriptionWithShipment clubMembership={clubMembership} />;
  }
  if (clubMembership.clubType === 'Controlled Subscription') {
    if (
      !clubMembership.activeClubPackageId ||
      !clubMembership.activeClubMemberShipmentId
    ) {
      return (
        <ActiveControlledSubscriptionMembership
          clubMembership={clubMembership}
        />
      );
    }
    return (
      <ActiveControlledSubscriptionWithShipment
        clubMembership={clubMembership}
      />
    );
  }
  // Traditional Clubs
  if (
    !clubMembership.activeClubPackageId ||
    !clubMembership.activeClubMemberShipmentId
  ) {
    return <ActiveTraditionalMembership clubMembership={clubMembership} />;
  }
  return <ActiveTraditionalWithShipment clubMembership={clubMembership} />;
};

export default ClubMembershipDisplay;
